(function () {
  function initCarousel(root) {
    var track = root.querySelector('.fp-carousel-track');
    var prev = root.querySelector('.fp-carousel-prev');
    var next = root.querySelector('.fp-carousel-next');
    if (!track) return;

    function scrollAmount() {
      var item = track.querySelector('.fp-carousel-item');
      if (!item) return 300;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 0);
      return item.getBoundingClientRect().width + gap;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.fp-carousel').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var carousels = e.target.querySelectorAll ? e.target.querySelectorAll('.fp-carousel') : [];
    carousels.forEach(initCarousel);
  });
})();
